import { useQuery } from '@tanstack/react-query'

import { authorizationClientAuthMethodsRetrieve } from 'src/api/main'

import { QR_LOGIN_METHOD } from '../providers/constants'

type QrLoginAvailability = {
  /** QR login is one of the org's enabled client methods. */
  isQrEnabled: boolean
  /** QR is the ONLY enabled method — there's no password/OTP/social fallback. */
  isQrOnly: boolean
}

/**
 * QR-login availability, read from the same cached `['client-auth-methods']`
 * query the Login page uses (shared, not a second request). `isQrOnly` lets the
 * layout/login decide where the QR panel lives so a QR-only org still has a way
 * in on every screen size.
 */
export const useQrLoginAvailability = (): QrLoginAvailability => {
  const { data } = useQuery({
    queryKey: ['client-auth-methods'],
    queryFn: async () => {
      const { data } = await authorizationClientAuthMethodsRetrieve()

      return data
    },
    staleTime: 5 * 60 * 1000
  })

  const methods = data?.auth_methods ?? []
  const isQrEnabled = methods.some(
    (method) => (method.method as string) === QR_LOGIN_METHOD && method.enabled
  )
  const hasNonQrMethod = methods.some(
    (method) => (method.method as string) !== QR_LOGIN_METHOD && method.enabled
  )

  return { isQrEnabled, isQrOnly: isQrEnabled && !hasNonQrMethod }
}
